import { render, staticRenderFns } from "./OrdersProductsCategoriesFiltersForm.vue?vue&type=template&id=081389cc&scoped=true&"
import script from "./OrdersProductsCategoriesFiltersForm.vue?vue&type=script&lang=js&"
export * from "./OrdersProductsCategoriesFiltersForm.vue?vue&type=script&lang=js&"
import style0 from "./OrdersProductsCategoriesFiltersForm.vue?vue&type=style&index=0&id=081389cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081389cc",
  null
  
)

export default component.exports